import { BasePasteOperationHelper } from '@project/components/label/helper/paste/base-paste-operation.helper';
import { Vector3 } from 'three';
import { CompositionContainer } from '@3d-scene/model3d/composition-container';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ArticleManager } from '@article/manager/article.manager';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { ProjectModel } from '@project/model/project.model';
import { ProjectArticleService } from '@project/service/project-article.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';

export class StaticPasteOperationHelper extends BasePasteOperationHelper {
  constructor(
    startPoint: Vector3,
    compositionContainer: CompositionContainer,
    articleManager: ArticleManager,
    projectModel: ProjectModel,
    projectArticleService: ProjectArticleService,
    articleContainerLoader: ArticleContainerLoader,
    articleContainerFactory: ArticleContainerFactory,
    detachArticleUsageService: DetachArticleUsageService
  ) {
    super(
      articleManager,
      projectModel,
      projectArticleService,
      articleContainerLoader,
      articleContainerFactory,
      detachArticleUsageService
    );
    this._startPoint = startPoint;
    this._compositionContainer = compositionContainer;
  }

  protected getMessageType(): string {
    return 'staticArticlesPasted';
  }
}
